<script setup lang="ts">
import type { NuxtError } from '#app';
import { getErrorMessage } from '@/utils/errors';
import { useThemeSettings } from '~/composables/useThemeSettings';

definePageMeta({
  title: 'Error Page',
  layout: 'default'
});

const appConfig = useAppConfig();
const { t } = useI18n();
const localePath = useLocalePath();

const { primaryColor, getColorValue, initializeThemeSettings } = useThemeSettings();

initializeThemeSettings();
const { error } = defineProps<{
  error: NuxtError;
}>();
</script>

<template>
  <UApp :ui="appConfig.ui">
    <NuxtLayout>
      <main class="flex items-center justify-center m-auto h-[70vh]">
        <div class="max-w-3xl w-full text-center py-20">
          <p :style="{ color: getColorValue(primaryColor) }" class="text-sm font-medium mb-4">
            {{ error.statusCode || '' }}
          </p>

          <h1 class="text-4xl md:text-5xl font-extrabold text-dark mb-4">
            {{ getErrorMessage(error.statusCode).title }}
          </h1>

          <p class="text-gray-400 max-w-xl mx-auto">
            {{ getErrorMessage(error.statusCode).message }}
          </p>

          <div class="mt-8">
            <UButton
              :to="localePath('/')"
              :style="{ backgroundColor: getColorValue(primaryColor) }"
              class="hover:opacity-90 font-medium text-dark px-5 py-2 rounded-md"
            >
              {{ t('errors.backToHome') }}
            </UButton>
          </div>
        </div>
      </main>
    </NuxtLayout>
  </UApp>
</template>
